import { render, staticRenderFns } from "./DefaultCard.vue?vue&type=template&id=2f77cf80"
import script from "./DefaultCard.vue?vue&type=script&lang=js"
export * from "./DefaultCard.vue?vue&type=script&lang=js"
import style0 from "./DefaultCard.vue?vue&type=style&index=0&id=2f77cf80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports